import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  Table,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { cancelLeave, getMyLeaveBalance, getMyLeaveHistory } from "../../Api/ApiUrlConst";
import { LeaveBalanceDto, LeaveHistoryDto } from "../../services/leaveModels";
import HolidayManager from "./HolidayManager";
import AdminLeaveHistory from "./AdminLeaveHistory";
import { useAuth } from "../../Context/AuthContext";
import LeaveHistory from "./LeaveHistory";

const LeaveDashboard: React.FC = () => {
  const [balances, setBalances] = useState<LeaveBalanceDto[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [leaves, setLeaves] = useState<LeaveHistoryDto[]>([]);
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();
  const { role } = useAuth();
  const Leave = role === 'Admin';
  const Leavehistory =
    role === "TeamLeader" ||
    role === "TeamMember" ||
    role === "ProjectManager";


  const goToDashboard = () => {
    if (role === "Admin") {
      navigate("/Admin");
    } else if (role === "ProjectManager") {
      navigate("/Project");
    } else if (role === "TeamLeader") {
      navigate("/TeamLead");
    }
    else if (role === "Client") {
      navigate("/client");
    }
    else {
      navigate("/Member");
    }
  };


  useEffect(() => {
    loadBalances();
  }, []);

  const loadBalances = async () => {
    try {
      const response = await getMyLeaveBalance();
      setBalances(response.data); // ✅ FIX
    } catch (error) {
      console.error("Failed to load leave balances", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = async () => {
    try {
      const res = await getMyLeaveHistory();
      setLeaves(res.data);
    } catch (err) {
      setError("Failed to load leave history.");
    } finally {
      setLoading(false);
    }
  };


  const handleCancel = async (leaveId: number) => {
    if (!window.confirm("Are you sure you want to cancel this leave?")) return;

    try {
      await cancelLeave(leaveId);
      loadHistory(); // refresh list
    } catch (err: any) {
      alert(err.response?.data || "Failed to cancel leave.");
    }
  };

  const canCancel = (fromDate: string) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return new Date(fromDate) >= today;
  };

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };




  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner color="primary" />
      </div>
    );
  }

  return (

    <div className="container-fluid mt-4 px-3">

      <div className="mt-4 d-flex flex-column flex-md-row gap-3 align-items-md-center">
        <h3 className="mb-0">Leave Dashboard</h3>


        <Button
          color="primary"
          style={{ height: "40px" }}
          onClick={() => navigate("/leave/apply")}
        >
          Apply Leave
        </Button>

        <div className="d-flex gap-2">
          <Button
            color="secondary"
            style={{ height: "40px", marginLeft: "1400px" }}
            onClick={goToDashboard}
          >
            Back
          </Button>
        </div>

      </div>






      <Row className="mt-3">
        {balances.map((leave) => {
          const usedPercent =
            leave.totalDays > 0
              ? (leave.usedDays / leave.totalDays) * 100
              : 0;

          const remainingColor =
            leave.remainingDays === 0
              ? "danger"
              : leave.remainingDays <= 2
                ? "warning"
                : "success";

          return (
            <Col
              xs="12"
              sm="6"
              md="6"
              lg="4"
              key={leave.leaveTypeId}
            >
              {["EL", "SL"].includes(leave.leaveTypeCode) && (
                <Card className="mb-4 shadow border-0 rounded-3">
                  <div
                    className="p-3 text-white rounded-top"
                    style={{
                      background:
                        "linear-gradient(45deg, #4e73df, #224abe)",
                    }}
                  >
                    <h5 className="mb-0">
                      {leave.leaveTypeName} ({leave.leaveTypeCode})
                    </h5>
                  </div>

                  <CardBody>
                    <Row className="text-center mb-1">
                      <Col>
                        <h6 className="text-muted">Total</h6>
                        <h4>{leave.totalDays}</h4>
                      </Col>

                      {leave.leaveTypeCode === "SL" && (
                        <Col>
                          <h6 className="text-muted">Used</h6>
                          <h4 className="text-danger">
                            {leave.usedDays}
                          </h4>
                        </Col>
                      )}

                      <Col>
                        <h6 className="text-muted">Remaining</h6>
                        <h4 className={`text-${remainingColor}`}>
                          {leave.remainingDays}
                        </h4>
                      </Col>
                    </Row>

                    <div className="mb-2">
                      <small className="text-muted">
                        Leave Usage ({usedPercent.toFixed(0)}%)
                      </small>

                      <div className="progress" style={{ height: "10px" }}>
                        <div
                          className={`progress-bar bg-${remainingColor}`}
                          style={{ width: `${usedPercent}%` }}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>
          );
        })}
      </Row>


      <Row className="mt-3">
        <Col xs="12" lg="4" className="mb-3" style={{ marginTop: "-265px" }}>
          <HolidayManager />
        </Col>

        <Col xs="12" lg="8">
          {Leave && <AdminLeaveHistory />}
          {Leavehistory && <LeaveHistory />}
        </Col>
      </Row>

    </div>
  );
};

export default LeaveDashboard;
